var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailApplication({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1745828255674,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2533,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 324.834l361.239 198.56L489.238 941l-346.03-195.153a29.882 29.882 0 0 1-15.204-25.558l-0.004-0.469V324.834z m779.999-11.312L908 719.82a29.882 29.882 0 0 1-15.208 26.027l-341.434 192.56 0.001-415.578L908 313.522zM503.297 73.86a29.934 29.934 0 0 1 29.406 0L872.1 265.27 519.852 472.002 153.954 270.88z",
    fill: "currentColor",
    "p-id": 2534
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailApplication);
export default __webpack_public_path__ + "static/media/detail-application.206a490bf2569a505fd71f18e439a851.svg";
export { ForwardRef as ReactComponent };